import gql from 'graphql-tag'

export const LIST_SHOWCASES = gql`
  query listShowcases {
    listShowcases {
      showcases {
        showcaseId
        componentKey
        component
        name
        domain
        multiEnv
        hostedZone
        imageName
        ttpsVersion
        description
        tags
        status
      }
    }
  }
`

export const LIST_SHOWCASE_ENVIRONMENTS = gql`
  query listShowcaseEnvironments($showcaseId: String!) {
    listShowcaseEnvironments(showcaseId: $showcaseId) {
      showcaseId
      componentKey
      component
      stackName
      imageId
      accountId
      region
      autoscalingGroupName
      status
      latestUpdate
    }
  }
`

export const LIST_SHOWCASE_IMAGES = gql`
  query listImages($showcaseId: String!) {
    listImages(showcaseId: $showcaseId) {
      imageName
      imageId
      ttpsVersion
      snapshotDate
      description
    }
  }
`

export const GET_OPERATION = gql`
  query getShowcaseOperation($showcaseId: String!, $operationId: String!) {
    getShowcaseOperation(showcaseId: $showcaseId, operationId: $operationId) {
      operationId
      name
      startDate
      endDate
      status
      userId
      parameters {
        key
        value
        type
      }
      error
    }
  }
`

export const ON_UPDATE_OPERATION = gql`
  subscription onUpdateOperation($operationId: String) {
    onUpdateOperation(operationId: $operationId) {
      operationId
      stepKey
      stepName
      showcaseId
      name
      comment
      creationDate
      startDate
      endDate
      latestUpdate
      status
      userId
      parameters {
        key
        value
        type
      }
      error
    }
  }
`

export const ON_UPDATE_OPERATION_STAGE = gql`
  subscription onUpdateOperationStage(
    $operationId: String
    $parentOperationId: String
  ) {
    onUpdateOperationStage(
      operationId: $operationId
      parentOperationId: $parentOperationId
    ) {
      stepKey
      stepName
      action
      status
      creationDate
      name
      operationId
      latestUpdate
      parameters
      startDate
      parentOperationId
      operationTargets {
        accountId
        documentName
        instanceIds
        region
        status
      }
      position
      showcaseId
      endDate
    }
  }
`

export const ON_UPDATE_OPERATION_STEP = gql`
  subscription onUpdateOperationStep($operationId: String!) {
    onUpdateOperationStep(operationId: $operationId) {
      operationId
      stepName
      stepKey
      startDate
      endDate
      latestUpdate
      status
      targets
      error
    }
  }
`

export const LIST_SHOWCASE_OPERATIONS = gql`
  query listOperationsOnShowcase(
    $showcaseId: String!
    $statusFilter: ShowcaseOperationStatus
  ) {
    listOperationsOnShowcase(
      showcaseId: $showcaseId
      input: { statusFilter: $statusFilter }
    ) {
      operations {
        operationId
        name
        startDate
        endDate
        status
        userId
        parameters {
          key
          value
          type
        }
        error
      }
    }
  }
`

export const LIST_SHOWCASE_OPERATION_STAGES = gql`
  query listShowcaseOperationStages(
    $showcaseId: String!
    $operationId: String!
  ) {
    listShowcaseOperationStages(
      showcaseId: $showcaseId
      operationId: $operationId
    ) {
      operationId
      parentOperationId
      position
      stepName
      startDate
      endDate
      latestUpdate
      status
      operationTargets {
        accountId
        region
        instanceIds
      }
      name
      error
    }
  }
`

export const LIST_SHOWCASE_OPERATION_STEPS = gql`
  query listShowcaseOperationSteps(
    $showcaseId: String!
    $operationId: String!
  ) {
    listShowcaseOperationSteps(
      showcaseId: $showcaseId
      operationId: $operationId
    ) {
      operationId
      stepName
      stepKey
      startDate
      endDate
      latestUpdate
      status
      targets
      error
    }
  }
`

export const OPREATION_STATUS_FILTER = gql`
  enum ShowcaseOperationStatus {
    INITIALIZING
    PENDING
    QUEUED
    RUNNING
    SUCCESS
    FAILED
    CANCELLED
    UNKNOWN
    ROLLBACK_IN_PROGRESS
    ROLLBACK_FINISHED
    ROLLBACK_FAILED
  }

  enum ShowcaseOperationScheduledStatus {
    ENABLED
    DISABLED
    DELETED
  }

  enum ShowcaseOperationSchedule {
    ONCE
    PERIODIC
  }
`

export const LIST_SCHEDULED_OPERATIONS = gql`
  query listScheduledOperationsOnShowcase(
    $showcaseId: String!
    $scheduleStatusFilter: ShowcaseOperationScheduledStatus
    $scheduleTypeFilter: ShowcaseOperationScheduleType
  ) {
    listScheduledOperationsOnShowcase(
      showcaseId: $showcaseId
      input: {
        scheduleStatusFilter: $scheduleStatusFilter
        scheduleTypeFilter: $scheduleTypeFilter
      }
    ) {
      scheduledOperations {
        showcaseId
        scheduleId
        name
        scheduleExpression
        scheduleStatus
        scheduleRuleName
        scheduleCreationDate
        scheduleType
        userId
        parameters
      }
    }
  }
`

export const DELETE_SCHEDULED_OPERATION = gql`
  mutation deleteScheduledShowcaseOperation(
    $showcaseId: String!
    $scheduleId: String!
  ) {
    deleteScheduledShowcaseOperation(
      input: { showcaseId: $showcaseId, scheduleId: $scheduleId }
    ) {
      showcaseId
      scheduleId
      name
      scheduleExpression
      scheduleStatus
      scheduleRuleName
      scheduleCreationDate
      scheduleType
      userId
      parameters
    }
  }
`

export const GET_SHOWCASE = gql`
  query getShowcase($showcaseId: String!) {
    getShowcase(showcaseId: $showcaseId) {
      showcaseId
      name
      domain
      hostedZone
      multiEnv
      imageName
      ttpsVersion
      description
      status
    }
  }
`

export const CREATE_SHOWCASE = gql`
  mutation createShowcase(
    $showcaseId: String!
    $name: String!
    $domain: String!
    $hostedZone: String!
    $multiEnv: Boolean!
    $imageName: String!
    $description: String
  ) {
    createShowcase(
      input: {
        showcaseId: $showcaseId
        name: $name
        domain: $domain
        hostedZone: $hostedZone
        multiEnv: $multiEnv
        imageName: $imageName
        description: $description
      }
    ) {
      showcaseId
      componentKey
      component
      name
      domain
      hostedZone
      multiEnv
      imageName
      ttpsVersion
      description
      status
    }
  }
`

export const APPLY_CUSTOM_APPLICATION_CONFIG = gql`
  mutation applyShowcaseApplicationConfig(
    $showcaseId: String!
    $applicationConfigS3Key: String!
  ) {
    applyShowcaseApplicationConfig(
      showcaseId: $showcaseId
      operationInput: { applicationConfigS3Key: $applicationConfigS3Key }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_APPLY_CUSTOM_APPLICATION_CONFIG = gql`
  mutation applyShowcaseApplicationConfig(
    $showcaseId: String!
    $applicationConfigS3Key: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleApplyShowcaseApplicationConfig(
      showcaseId: $showcaseId
      operationInput: { applicationConfigS3Key: $applicationConfigS3Key }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const APPLY_CUSTOMIZING = gql`
  mutation applyShowcaseCustomizing(
    $showcaseId: String!
    $customizingS3Key: String!
  ) {
    applyShowcaseCustomizing(
      showcaseId: $showcaseId
      operationInput: { customizingS3Key: $customizingS3Key }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_APPLY_CUSTOMIZING = gql`
  mutation scheduleApplyShowcaseCustomizing(
    $showcaseId: String!
    $customizingS3Key: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleApplyShowcaseCustomizing(
      showcaseId: $showcaseId
      operationInput: { customizingS3Key: $customizingS3Key }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const UPDATE_LICENSE = gql`
  mutation updateShowcaseLicense($showcaseId: String!, $licenseS3Key: String!) {
    updateShowcaseLicense(
      showcaseId: $showcaseId
      operationInput: { licenseS3Key: $licenseS3Key }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_UPDATE_LICENSE = gql`
  mutation scheduleUpdateShowcaseLicense(
    $showcaseId: String!
    $licenseS3Key: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleUpdateShowcaseLicense(
      showcaseId: $showcaseId
      operationInput: { licenseS3Key: $licenseS3Key }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const ADD_RECORDER_CONFIG = gql`
  mutation addShowcaseRecorderConfig(
    $showcaseId: String!
    $recorderConfigS3Key: String!
    $configVersion: String!
  ) {
    addShowcaseRecorderConfig(
      showcaseId: $showcaseId
      operationInput: {
        recorderConfigS3Key: $recorderConfigS3Key
        configVersion: $configVersion
      }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_ADD_RECORDER_CONFIG = gql`
  mutation scheduleAddShowcaseRecorderConfig(
    $showcaseId: String!
    $recorderConfigS3Key: String!
    $configVersion: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleAddShowcaseRecorderConfig(
      showcaseId: $showcaseId
      operationInput: {
        recorderConfigS3Key: $recorderConfigS3Key
        configVersion: $configVersion
      }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const UPDATE_MINOR_VERSION = gql`
  mutation updateShowcaseMinorVersion(
    $showcaseId: String!
    $majorVersion: String!
    $buildNr: String!
  ) {
    updateShowcaseMinorVersion(
      showcaseId: $showcaseId
      operationInput: { majorVersion: $majorVersion, buildNr: $buildNr }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_UPDATE_MINOR_VERSION = gql`
  mutation scheduleUpdateShowcaseMinorVersion(
    $showcaseId: String!
    $majorVersion: String!
    $buildNr: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleUpdateShowcaseMinorVersion(
      showcaseId: $showcaseId
      operationInput: { majorVersion: $majorVersion, buildNr: $buildNr }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const UPDATE_PROPERTIES = gql`
  mutation updateShowcaseProperties(
    $showcaseId: String!
    $name: String
    $description: String
  ) {
    updateShowcaseProperties(
      showcaseId: $showcaseId
      operationInput: { name: $name, description: $description }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_UPDATE_PROPERTIES = gql`
  mutation scheduleUpdateShowcaseProperties(
    $showcaseId: String!
    $name: String
    $description: String
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleUpdateShowcaseProperties(
      showcaseId: $showcaseId
      operationInput: { name: $name, description: $description }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const UPDATE_URL = gql`
  mutation updateShowcaseUrl(
    $showcaseId: String!
    $domain: String
    $hostedZone: String
  ) {
    updateShowcaseUrl(
      showcaseId: $showcaseId
      operationInput: { domain: $domain, hostedZone: $hostedZone }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_UPDATE_URL = gql`
  mutation scheduleUpdateShowcaseUrl(
    $showcaseId: String!
    $domain: String
    $hostedZone: String
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleUpdateShowcaseUrl(
      showcaseId: $showcaseId
      operationInput: { domain: $domain, hostedZone: $hostedZone }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const UPDATE_MULTI_ENV = gql`
  mutation updateShowcaseMultiEnv($showcaseId: String!, $multiEnv: Boolean!) {
    updateShowcaseMultiEnv(
      showcaseId: $showcaseId
      operationInput: { multiEnv: $multiEnv }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_UPDATE_MULTI_ENV = gql`
  mutation scheduleUpdateShowcaseMultiEnv(
    $showcaseId: String!
    $multiEnv: Boolean!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleUpdateShowcaseMultiEnv(
      showcaseId: $showcaseId
      operationInput: { multiEnv: $multiEnv }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const CREATE_IMAGE = gql`
  mutation createShowcaseImage(
    $showcaseId: String!
    $imageName: String!
    $description: String!
  ) {
    createShowcaseImage(
      showcaseId: $showcaseId
      operationInput: { imageName: $imageName, description: $description }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_CREATE_IMAGE = gql`
  mutation scheduleCreateShowcaseImage(
    $showcaseId: String!
    $imageName: String!
    $description: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleCreateShowcaseImage(
      showcaseId: $showcaseId
      operationInput: { imageName: $imageName, description: $description }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const SET_TO_IMAGE = gql`
  mutation updateShowcaseEnvironmentImage(
    $showcaseId: String!
    $imageName: String!
  ) {
    updateShowcaseEnvironmentImage(
      showcaseId: $showcaseId
      operationInput: { imageName: $imageName }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_SET_TO_IMAGE = gql`
  mutation scheduleUpdateShowcaseEnvironmentImage(
    $showcaseId: String!
    $imageName: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleUpdateShowcaseEnvironmentImage(
      showcaseId: $showcaseId
      operationInput: { imageName: $imageName }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const SET_TO_LATEST_IMAGE = gql`
  mutation setToLatestImage($showcaseId: String!, $sourceShowcaseId: String!) {
    setToLatestImage(
      showcaseId: $showcaseId
      operationInput: { sourceShowcaseId: $sourceShowcaseId }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_SET_TO_LATEST_IMAGE = gql`
  mutation scheduleSetToLatestImage(
    $showcaseId: String!
    $sourceShowcaseId: String!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleSetToLatestImage(
      showcaseId: $showcaseId
      operationInput: { sourceShowcaseId: $sourceShowcaseId }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const GENERATE_PRESIGNED_URL = gql`
  query generatePresignedUrl($showcaseId: String!, $key: String!) {
    generatePresignedUrl(showcaseId: $showcaseId, key: $key) {
      url
    }
  }
`

export const INPUTS = gql`
  input ShowcaseLocation {
    region: String!
    accountId: String!
  }
`

export const CREATE_ENVIRONMENTS = gql`
  mutation createShowcaseEnvironments(
    $showcaseId: String!
    $targets: [ShowcaseLocation!]!
  ) {
    createShowcaseEnvironments(
      showcaseId: $showcaseId
      operationInput: { targets: $targets }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_CREATE_ENVIRONMENTS = gql`
  mutation scheduleCreateShowcaseEnvironments(
    $showcaseId: String!
    $targets: [ShowcaseLocation!]!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleCreateShowcaseEnvironments(
      showcaseId: $showcaseId
      operationInput: { targets: $targets }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`

export const DELETE_ENVIRONMENTS = gql`
  mutation deleteShowcaseEnvironments(
    $showcaseId: String!
    $targets: [ShowcaseLocation!]!
  ) {
    deleteShowcaseEnvironments(
      showcaseId: $showcaseId
      operationInput: { targets: $targets }
    ) {
      operationId
      showcaseId
      name
      status
    }
  }
`

export const SCHEDULE_DELETE_ENVIRONMENTS = gql`
  mutation scheduleDeleteShowcaseEnvironments(
    $showcaseId: String!
    $targets: [ShowcaseLocation!]!
    $scheduleExpression: String!
    $scheduleType: ShowcaseOperationScheduleType!
  ) {
    scheduleDeleteShowcaseEnvironments(
      showcaseId: $showcaseId
      operationInput: { targets: $targets }
      scheduleInput: {
        scheduleExpression: $scheduleExpression
        scheduleType: $scheduleType
      }
    ) {
      scheduleId
      scheduleStatus
      showcaseId
      name
    }
  }
`
